module.exports = __webpack_public_path__ + "img/btn-pre-reservation-no.1c9709d4.png";